/**
 * @fileoverview gRPC-Web generated client stub for usrpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.usrpb = require('./access_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.usrpb.UsrAccessServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.usrpb.UsrAccessServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.ListUsrAccessRequest,
 *   !proto.usrpb.ListUsrAccessResponse>}
 */
const methodDescriptor_UsrAccessService_ListUsrAccess = new grpc.web.MethodDescriptor(
  '/usrpb.UsrAccessService/ListUsrAccess',
  grpc.web.MethodType.UNARY,
  proto.usrpb.ListUsrAccessRequest,
  proto.usrpb.ListUsrAccessResponse,
  /**
   * @param {!proto.usrpb.ListUsrAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ListUsrAccessResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.ListUsrAccessRequest,
 *   !proto.usrpb.ListUsrAccessResponse>}
 */
const methodInfo_UsrAccessService_ListUsrAccess = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.ListUsrAccessResponse,
  /**
   * @param {!proto.usrpb.ListUsrAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ListUsrAccessResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.ListUsrAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.ListUsrAccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.ListUsrAccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.UsrAccessServiceClient.prototype.listUsrAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.UsrAccessService/ListUsrAccess',
      request,
      metadata || {},
      methodDescriptor_UsrAccessService_ListUsrAccess,
      callback);
};


/**
 * @param {!proto.usrpb.ListUsrAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.ListUsrAccessResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.UsrAccessServicePromiseClient.prototype.listUsrAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.UsrAccessService/ListUsrAccess',
      request,
      metadata || {},
      methodDescriptor_UsrAccessService_ListUsrAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.UpdateAmountLimitRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_UsrAccessService_UpdateAmountLimit = new grpc.web.MethodDescriptor(
  '/usrpb.UsrAccessService/UpdateAmountLimit',
  grpc.web.MethodType.UNARY,
  proto.usrpb.UpdateAmountLimitRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.UpdateAmountLimitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.UpdateAmountLimitRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_UsrAccessService_UpdateAmountLimit = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.UpdateAmountLimitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usrpb.UpdateAmountLimitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.UsrAccessServiceClient.prototype.updateAmountLimit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.UsrAccessService/UpdateAmountLimit',
      request,
      metadata || {},
      methodDescriptor_UsrAccessService_UpdateAmountLimit,
      callback);
};


/**
 * @param {!proto.usrpb.UpdateAmountLimitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.UsrAccessServicePromiseClient.prototype.updateAmountLimit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.UsrAccessService/UpdateAmountLimit',
      request,
      metadata || {},
      methodDescriptor_UsrAccessService_UpdateAmountLimit);
};


module.exports = proto.usrpb;

